import { format } from 'date-fns';

import { cn } from '@/lib/utils';

import styles from '../../../booking.module.css';
import { parseDate } from '../utils';

export const TimePickerColumnHeader = ({ dateString }: { dateString: string }): JSX.Element => {
  const date = parseDate(dateString);
  const weekday = format(date, 'EEE');
  const day = format(date, 'd');
  const month = format(date, 'LLL');

  return (
    <div
      className={cn(
        styles.timeColumnHeader,
        styles.timeslotsColumn,
        'text-center d-flex flex-column'
      )}
    >
      <small>{weekday}</small>
      <small className="text-bold">
        {month} {day}
      </small>
    </div>
  );
};
